import Button from "@components/common/Button/Button";
import type { ProfileActionButtonsProps } from "../types";

const ProfileActionButtons: React.FC<ProfileActionButtonsProps> = ({ isEditMode, isUpdating, onEdit, onCancel, t }) => {
	return (
		<div className="mt-4 flex items-center justify-end gap-3 border-t border-border-strong bg-surface px-8 pb-6 pt-5 sm:px-10">
			{isEditMode ? (
				<>
					<Button variant="tertiary" disabled={isUpdating} onClick={onCancel} className="min-w-[130px]">
						{t("psdaCommon.common.buttons.cancel")}
					</Button>
					<Button type="submit" disabled={isUpdating} loading={isUpdating} className="min-w-[150px]">
						{t("psdaCommon.profile.buttons.save")}
					</Button>
				</>
			) : (
				<Button onClick={onEdit}>{t("psdaCommon.profile.buttons.edit")}</Button>
			)}
		</div>
	);
};

export default ProfileActionButtons;
